import { render, staticRenderFns } from "./PropsForm.vue?vue&type=template&id=235ab419"
import script from "./PropsForm.vue?vue&type=script&lang=js"
export * from "./PropsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports